import { render, staticRenderFns } from "./PageHistory.vue?vue&type=template&id=7315a00e&scoped=true"
import script from "./PageHistory.vue?vue&type=script&lang=js"
export * from "./PageHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7315a00e",
  null
  
)

export default component.exports